/**
 * Prevent emojis being entered into inputs/textareas on the site
 * and prevent submission of space-only values
 * * Need to listen for DOMNodeInserted because BOLD/SC Products inserts its fields
 * * post page load with JavaScript
 *
 * @author Matt <matt@joipolloi.com>
 * @package Minifigs 2.0
 */

const stripEmojis = (str) =>
    str
        .replace(
            /(?![*#0-9]+)[\p{Emoji}\p{Emoji_Modifier}\p{Emoji_Component}\p{Emoji_Modifier_Base}\p{Emoji_Presentation}]/gu,
            ''
        )
        .replace(/\s+/g, ' ');

const isSpaceOnly = (str) => str.trim().length === 0;

const preventEmojis = () => {
    const productContainer = document.querySelector('.product');
    if (!productContainer) return;

    const processedInputs = new WeakSet();
    const processedForms = new WeakSet();

    const handleNodeUpdate = () => {
        const inputs = document.querySelectorAll('textarea, input[type="text"] ');
        inputs.forEach((input) => {
            // Only add input listener once per element
            if (!processedInputs.has(input)) {
                input.addEventListener('input', () => {
                    const strippedValue = stripEmojis(input.value);
                    input.value = strippedValue;
                });
                processedInputs.add(input);
            }

            // Prevent form submission if the input contains only spaces
            const form = input.closest('form');
            if (form && !processedForms.has(form)) {
                form.addEventListener(
                    'submit',
                    (e) => {
                        // Check all text inputs/textareas in the form
                        const formInputs = form.querySelectorAll('textarea, input[type="text"]');
                        let hasSpaceOnlyValue = false;

                        formInputs.forEach((formInput) => {
                            if (formInput.value && isSpaceOnly(formInput.value)) {
                                hasSpaceOnlyValue = true;
                                formInput.setCustomValidity('Please enter a valid value.');
                                formInput.reportValidity();
                            } else {
                                formInput.setCustomValidity('');
                            }
                        });

                        if (hasSpaceOnlyValue) {
                            e.preventDefault();
                            e.stopPropagation();
                            e.stopImmediatePropagation();
                            return false;
                        }
                    },
                    true // Use capture phase
                );
                processedForms.add(form);
            }
        });
    };

    const observer = new MutationObserver((mutationList) =>
        mutationList
            .filter((m) => m.type === 'childList')
            .forEach((m) => {
                m.addedNodes.forEach(handleNodeUpdate);
            })
    );
    observer.observe(productContainer, { childList: true, subtree: true });
};

export default preventEmojis;
